<label [attr.for]="prfFormControlElement?.id" class="prf-form-label" [class.topped-out]="toLabel">
  <ng-content></ng-content>
</label>
